import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { useTheme } from '@material-ui/core/styles';

const ConceptFrequency = () => {
  const theme = useTheme();

  return (
    <Box marginBottom={4}>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
        gutterBottom
        color="primary"
        align="center"
      >
        El concepto
      </Typography>
      <Typography variant="h4" fontWeight={700} align="center" color="primary" gutterBottom>
        Frecuencia que genera confianza
      </Typography>
      <Box
        sx={{
          maxWidth: 720,
          mx: 'auto',
          p: 2,
          borderRadius: 2,
          border: `1px solid ${theme.palette.divider}`,
          bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
        }}
      >
        <Typography variant="body1" color="textSecondary" paragraph sx={{ mb: 0 }}>
          La propuesta se basa en la <strong>ubicuidad</strong>: el nombre de <strong>Danimar</strong> presente en cada
          rincón de la plataforma, asociado a eficiencia y solución inmediata para el hogar y la industria. No es una
          mención aislada: es <strong>presencia constante</strong> que construye recordación de marca.
        </Typography>
      </Box>
    </Box>
  );
};

export default ConceptFrequency;
